import React, { Component } from "react";
import debounce from "lodash/debounce";

// Components
import ErrorWrap from "../utils/error-success/ErrorWrap";

// Utils
import PermalinkChecker from "../../utils/PermalinkChecker";

// CSS
import "../../css/permalinks.css";

class PermalinkField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: "",
			checkingPermalink: false
		};

		this.permalinkChecker = new PermalinkChecker(props.tableName, props.id);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.controlFieldValue !== this.props.controlFieldValue) {
			this.handleKeyPressPermalink(nextProps.controlFieldValue);
		}

		// Record id may be received via the parent component
		if (nextProps.id !== this.props.id) {
			this.permalinkChecker = new PermalinkChecker(nextProps.tableName, nextProps.id);
		}
	}

	handleInputChange(event) {
		const value = event.target.value;
		this.props.handleChange(value);
		this.handleKeyPressPermalink(value);
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.props.handleSubmit();
		}
	}

	handleKeyPressPermalink = debounce(function(value) {
		// Set the loader to visible
		this.setState(
			{
				checkingPermalink: true,
				error: ""
			},
			() => {
				// Check the permalink
				this.permalinkChecker
					.checkPermalink(value)
					.then(resp => {
						// Set the loader to hidden and the permalink data
						this.setState({
							checkingPermalink: false
						});

						// Notify parent that the permalink value has changed
						this.props.handleChange(resp);
					})
					.catch(err => {
						this.setState({
							error: err,
							checkingPermalink: false
						});
					});
			}
		);
	}, 1000);

	render() {
		const { value, fieldError } = this.props;
		const { checkingPermalink, error } = this.state;

		return (
			<div>
				{error && <ErrorWrap animate={1}>{error}</ErrorWrap>}
				{fieldError && <ErrorWrap animate={1}>{fieldError}</ErrorWrap>}
				<div className="permalink_field_wrapper">
					<input tabIndex="-1" type="text" id="permalink" value={value} className="permalink_input" placeholder="Permalink" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
					<div className={`icon_wrapper` + (checkingPermalink ? " active" : "")}>
						<div className="permalink_preloader icon-spinner" />
					</div>
				</div>
			</div>
		);
	}
}

export default PermalinkField;



// WEBPACK FOOTER //
// ./src/components/utils/PermalinkField.js